import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

/**
 * Reusable loading skeleton for page transitions and data fetching.
 * Variants match common page layouts in the dashboard.
 *
 * Usage: <PageSkeleton variant="table" />
 */
function PageSkeleton({ variant = 'table' }) {
  if (variant === 'table') {
    return (
      <Box sx={{ p: 3, maxWidth: 1200 }}>
        <Skeleton variant="text" width="25%" height={40} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={44} sx={{ mb: 1, borderRadius: 1 }} />
        {[...Array(8)].map((_, i) => (
          <Skeleton key={i} variant="rectangular" height={36} sx={{ mb: 0.5, borderRadius: 0.5 }} />
        ))}
      </Box>
    );
  }

  if (variant === 'cards') {
    return (
      <Box sx={{ p: 3, maxWidth: 1200 }}>
        <Skeleton variant="text" width="25%" height={40} sx={{ mb: 2 }} />
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 2 }}>
          {[...Array(6)].map((_, i) => (
            <Skeleton key={i} variant="rectangular" height={180} sx={{ borderRadius: 2 }} />
          ))}
        </Box>
      </Box>
    );
  }

  if (variant === 'chart') {
    return (
      <Box sx={{ p: 3, maxWidth: 1200 }}>
        <Skeleton variant="text" width="25%" height={40} sx={{ mb: 2 }} />
        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
          {[...Array(4)].map((_, i) => (
            <Skeleton key={i} variant="rectangular" width={80} height={32} sx={{ borderRadius: 1 }} />
          ))}
        </Box>
        <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
      </Box>
    );
  }

  if (variant === 'dashboard') {
    return (
      <Box sx={{ p: 3, maxWidth: 1200 }}>
        <Skeleton variant="text" width="25%" height={40} sx={{ mb: 2 }} />
        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
          {[...Array(4)].map((_, i) => (
            <Skeleton key={i} variant="rectangular" height={80} sx={{ flex: 1, borderRadius: 2 }} />
          ))}
        </Box>
        <Skeleton variant="rectangular" height={44} sx={{ mb: 1, borderRadius: 1 }} />
        {[...Array(6)].map((_, i) => (
          <Skeleton key={i} variant="rectangular" height={36} sx={{ mb: 0.5, borderRadius: 0.5 }} />
        ))}
      </Box>
    );
  }

  // Fallback: simple table
  return (
    <Box sx={{ p: 3, maxWidth: 1200 }}>
      <Skeleton variant="text" width="25%" height={40} sx={{ mb: 2 }} />
      {[...Array(6)].map((_, i) => (
        <Skeleton key={i} variant="rectangular" height={36} sx={{ mb: 0.5, borderRadius: 0.5 }} />
      ))}
    </Box>
  );
}

export default PageSkeleton;
